import { Field } from "redux-form"
import { InputField } from "../../../inputs/connected-input-fields"
import React, { ReactNode } from "react"
import { Avatar, Tooltip } from "antd"
import { getFileNameFromUrl, getIcon } from "../../../components/helpers"
import { useSelector } from "react-redux"
import selectors from "../../../store/selectors"
import { TitledLink } from "../../../types"
import { validatedIf, required } from "../../validators"
import { useIntl } from "react-intl"

interface Props {
  name: string
  children?: ReactNode
  disabled?: boolean
  field: TitledLink
}

export const DocumentFields = ({ children, disabled, field }: Props) => {
  const intl = useIntl()
  const mediaUrl = useSelector(selectors.selectMediaUrl)
  const url = mediaUrl(field.url)

  return (
    <div className="link-details">
      <div className="tw-flex tw-gap-3 tw-mt-6">
        <div className="tw-flex tw-items-center tw-gap-2 tw-h-[44px]">
          <Tooltip placement="topLeft" title={getFileNameFromUrl(url)}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <Avatar shape="square">{getIcon(url, { isTwoTone: true })}</Avatar>
            </a>
          </Tooltip>
        </div>
        <Field
          name="title"
          component={InputField}
          placeholder={intl.formatMessage({
            id: "input.addDocument.documentField.placeholder",
          })}
          disabled={disabled}
          validate={validatedIf(!disabled, required)}
          className="tw-flex-1 tw-mt-0"
        />
        <div className="tw-flex tw-items-center tw-gap-2 tw-h-[44px]">{children}</div>
      </div>
    </div>
  )
}
